/**
 * Formats a code+name pair for display (HU-01/HU-14, RN01.4/RN01.6/RN14.1): an
 * empty/NULL "name" renders as an empty gap (PO decision 23/07/2026 — the
 * contract admits "guion '—' o vacío" and the dash was visual noise), and it is
 * never substituted by the "code".
 *
 * Extracted out of `workflow2.0/utils.js` (which re-exports it for backward
 * compatibility) so consumers outside the workflow graph module do not need to
 * pull in that file's other dependencies (e.g. the ESM-only `uuid` package).
 *
 * @param {string} code
 * @param {string} name
 * @returns {string}
 */
export const formatCodeName = (code, name) => (code || '') + (name ? ' ' + name : '')

export default formatCodeName
